import { configureStore } from "@reduxjs/toolkit";

// Placeholder reducer to avoid Redux warnings
const placeholderReducer = (state = {}) => state;

// Initial store setup - slices will be added as needed
export const store = configureStore({
  reducer: {
    placeholder: placeholderReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
